export interface ConditionalProps {
  showIf: boolean;
  children: any;
}

/**
 * Renders the children only if the condition is true.
 *
 * NOTE: When using shallow rendering, the `props.children` still show up in the shallow rendered output
 * of the parent component. If you want to test the existence of the child components in unit tests,
 * using the conditional() function from shared widgets might be a better choice.
 *
 * TODO: Should we just remove this?
 */
export function Conditional(props: ConditionalProps): JSX.Element {
  if (props.showIf) {
    return props.children;
  } else {
    return null;
  }
}
